import { api } from './authService'; // Importamos la instancia configurada de Axios

/**
 * @description Obtiene la lista de todas las órdenes de mantenimiento.
 * Solo accesible por roles ADMIN y SUPERVISOR.
 * @returns {Promise<import('axios').AxiosResponse>} La respuesta de la API con el listado de órdenes.
 */
const getAllMaintenanceOrders = (params = {}) => {
  return api.get('/maintenance-orders', { params });
};

/**
 * @description Obtiene el detalle completo de una orden de mantenimiento por su ID.
 * @param {number | string} id El ID de la orden a obtener.
 * @returns {Promise<import('axios').AxiosResponse>} La respuesta de la API con la orden detallada.
 */
const getMaintenanceOrderById = (id) => {
  return api.get(`/maintenance-orders/${id}`);
};

/**
 * @description Crea una nueva orden de mantenimiento.
 * @param {object} data Los datos de la orden a crear.
 * @param {string}        data.maintenance_type Tipo de mantenimiento (PREVENTIVE | CORRECTIVE).
 * @param {number}        data.project_id       ID del proyecto asociado.
 * @param {number}        data.equipment_id     ID del equipo al que aplica la orden.
 * @param {number}        data.assigned_to      ID del técnico asignado.
 * @param {string}        [data.scheduled_for]  Fecha programada (ISO date string), opcional.
 * @param {string}        [data.notes]          Notas u observaciones, opcional.
 * @returns {Promise<import('axios').AxiosResponse>} La respuesta de la API con la orden creada.
 */
const createMaintenanceOrder = (data) => {
  return api.post('/maintenance-orders', data);
};

/**
 * @description Cancela una orden de mantenimiento por su ID.
 * Solo aplicable a órdenes que no estén en estado CANCELED ni COMPLETED.
 * @param {number | string} id El ID de la orden a cancelar.
 * @returns {Promise<import('axios').AxiosResponse>} La respuesta de la API con la orden actualizada.
 */
const cancelMaintenanceOrder = (id) => {
  return api.patch(`/maintenance-orders/${id}/cancel`);
};

/**
 * @description Actualiza/reasigna una orden de mantenimiento existente (editar).
 * Usa `PATCH /maintenance-orders/:id` (ADMIN/SUPERVISOR), que acepta cualquier
 * combinación de: maintenance_type, project_id, equipment_id, assigned_to,
 * scheduled_for, notes, status.
 * @param {number | string} id El ID de la orden a actualizar.
 * @param {object} data Los campos a actualizar.
 * @returns {Promise<import('axios').AxiosResponse>} La respuesta de la API con la orden actualizada.
 */
const updateMaintenanceOrder = (id, data) => {
  return api.patch(`/maintenance-orders/${id}`, data);
};

const maintenanceOrderService = {
  getAllMaintenanceOrders,
  getMaintenanceOrderById,
  createMaintenanceOrder,
  cancelMaintenanceOrder,
  updateMaintenanceOrder,
};

export default maintenanceOrderService;
